module.exports = __webpack_public_path__ + "static/img/far4_active.322d1699.png";